import { getNamespace } from "@/namespace";
import { getSiteSpecificKey, sessionStorage } from "./storage";

/**
 * Key for storing dismissed Announcement IDs in session storage.
 */
function dismissedKey(siteId: string) {
  return getSiteSpecificKey(`${getNamespace()}_announcement_dismissed`, siteId);
}

/**
 * Read dismissed Announcement IDs from session storage.
 */
export function readDismissedAnnouncementIds(siteId: string): number[] {
  const stored = sessionStorage.getJSON<number[]>(dismissedKey(siteId));

  if (!Array.isArray(stored)) {
    return [];
  }

  return stored.filter((id): id is number => typeof id === "number");
}

/**
 * Dismiss an Announcement by ID.
 */
export function dismissAnnouncement(siteId: string, id: number): number[] {
  const current = readDismissedAnnouncementIds(siteId);

  if (current.includes(id)) {
    return current;
  }

  const next = [...current, id];

  sessionStorage.setJSON(dismissedKey(siteId), next);

  return next;
}
